// Liquid serializes Shopify date_time metafields to Unix seconds before they
// reach the browser. Explicit-offset ISO timestamps are also accepted.
function parseGiftScheduleTime(value) {
  const text = (value || '').trim();
  if (!text) return null;
  if (/^-?\d+$/.test(text)) {
    const timestamp = Number(text) * 1000;
    return Number.isSafeInteger(timestamp) && Math.abs(timestamp) <= 8640000000000000 ? timestamp : NaN;
  }
  const match = text.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|([+-])(\d{2}):(\d{2}))$/);
  if (!match) return NaN;
  const [, year, month, day, hour, minute, second = '00', zone, sign, offsetHour, offsetMinute] = match;
  const parts = [year, month, day, hour, minute, second].map(Number);
  const [y, m, d, h, min, sec] = parts;
  if (y < 1000 || m < 1 || m > 12 || d < 1 || h > 23 || min > 59 || sec > 59) return NaN;
  const local = Date.UTC(y, m - 1, d, h, min, sec);
  if (new Date(local).getUTCDate() !== d) return NaN;
  let offset = 0;
  if (zone !== 'Z') {
    if (Number(offsetHour) > 14 || Number(offsetMinute) > 59 || (Number(offsetHour) === 14 && Number(offsetMinute) !== 0)) return NaN;
    offset = (Number(offsetHour) * 60 + Number(offsetMinute)) * (sign === '+' ? 1 : -1);
  }
  return local - offset * 60000;
}

function getGiftScheduleState(startsAt, endsAt, now = Date.now()) {
  const start = parseGiftScheduleTime(startsAt);
  const end = parseGiftScheduleTime(endsAt);
  if (Number.isNaN(start) || Number.isNaN(end) || (start !== null && end !== null && end <= start)) return 'invalid';
  if (start === null || end === null) return 'unconfigured';
  if (now < start) return 'upcoming';
  if (now >= end) return 'ended';
  return 'active';
}

if (typeof customElements !== 'undefined' && !customElements.get('product-gift-selector')) {
  customElements.define('product-gift-selector', class extends HTMLElement {
    connectedCallback() {
      this.updateGroupChoices = () => {
        this.querySelectorAll('[data-gift-group]').forEach((group) => {
          const selected = group.querySelector('input[name="gift_variant_id"]:checked');
          group.querySelector('[data-gift-group-choice]').textContent = selected
            ? `Selected: ${selected.dataset.variantTitle}` : 'Choose an option';
        });
      };
      this.addEventListener('change', this.updateGroupChoices);
      this.updateGroupChoices();
      this.refresh = () => {
        clearTimeout(this.timer);
        this.updateSchedule();
        const now = Date.now();
        const boundaries = [this.dataset.startsAt, this.dataset.endsAt]
          .map(parseGiftScheduleTime).filter((time) => time !== null && time > now);
        if (this.scheduleState === 'invalid' || this.scheduleState === 'unconfigured' || !boundaries.length) return;
        const delay = Math.min(60000, ...boundaries.map((time) => time - now));
        this.timer = setTimeout(this.refresh, Math.max(1, delay));
      };
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.refresh);
      this.refresh();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.updateGroupChoices);
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
    }

    updateSchedule() {
      const state = getGiftScheduleState(this.dataset.startsAt, this.dataset.endsAt);
      this.scheduleState = state;
      const active = state === 'active';
      this.dataset.giftActive = String(active);
      const fieldset = this.querySelector('fieldset');
      fieldset.hidden = !active;
      fieldset.disabled = !active;
      this.hidden = !active && this.dataset.designMode !== 'true';
      if (!active) {
        this.querySelectorAll('input[name="gift_variant_id"]').forEach((input) => { input.checked = false; });
        this.querySelector('.product-gift-selector__error').hidden = true;
      } else {
        const options = Array.from(this.querySelectorAll('input[name="gift_variant_id"]')).filter((input) => !input.disabled);
        if (options.length && !options.some((input) => input.checked)) {
          options[0].checked = true;
          options[0].closest?.('details[data-gift-group]')?.setAttribute?.('open', '');
        }
      }
      this.updateGroupChoices?.();
      const status = this.querySelector('[data-gift-schedule-status]');
      if (status) {
        status.hidden = active;
        status.textContent = {
          unconfigured: '赠品区未显示：请在商品详情同时填写“赠品活动开始时间”和“赠品活动结束时间”。',
          upcoming: `赠品区尚未开始，将于 ${this.dataset.startsAtLabel || this.dataset.startsAt} 显示。`,
          ended: `赠品区已于 ${this.dataset.endsAtLabel || this.dataset.endsAt} 结束显示。`,
          invalid: '赠品活动时间配置有误：请在商品详情使用“日期和时间”类型的元字段，并确保结束时间晚于开始时间。',
        }[state] || '';
      }
    }
  });
}

if (typeof module !== 'undefined' && module.exports) module.exports = { parseGiftScheduleTime, getGiftScheduleState };
